
import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator'
import Profile from '@/models/Profile'
import FeatureAccess from '@/models/FeatureAccess'
import Company from '@/models/Company'
import User from '@/models/User'
import ViewModel from '@/models/ViewModel'
import { permissionOptions } from '@/models/DefaultPermissions'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import tenancy from '@/plugins/tenancy'

@Component({
  components: {
    SelectPicker,
  },
})
export default class AccessControlV2 extends ViewModel {
  public base_profile: Profile = new Profile()

  public local_access: FeatureAccess[] = []

  public allPermissionsActive: boolean = false

  @Prop()
  public ignoresCompany!: boolean

  @Prop()
  public access!: FeatureAccess[]

  @Prop({ default: 'profile' })
  public mode!: string

  @Prop({ default: 'central' })
  public scope!: string

  @Prop({ default: false })
  public root!: boolean

  @Prop({ default: false })
  public disabled!: boolean

  @Prop()
  public company!: Company

  @Prop({ default: 'merge' })
  public action!: string

  public selected: string = 'merge'

  @Watch('selected')
  public onSelectedChange(newValue: string) {
    this.$emit('update:action', newValue)
  }

  private models: string[] = []

  private actions: string[] = []

  public ready: boolean = false

  // Action icon mapping
  public actionIcons: any = {
    view: 'eye',
    edit: 'pencil-alt',
    delete: 'trash-alt',
    options: 'sliders-h',
    export: 'file-export',
    approve: 'check-circle',
    pay: 'money-check',
    create: 'plus',
    add: 'plus',
    all: 'lock',
    batch: 'boxes',
    monitor: 'binoculars',
    review: 'spell-check',
  }

  public getActionIcon(action: string): string {
    return this.actionIcons[action] || 'question-circle'
  }

  public toggleAllPermissions(): void {
    this.allPermissionsActive = !this.allPermissionsActive
    this.onPermissionChange('all', 'all', this.allPermissionsActive)
  }

  public getFeatureOptions(key: string) {
    // @ts-ignore
    return permissionOptions[key]
  }

  public togglePermission(model: string, action: string) {
    const index = this.getAccessIndex(model, action)
    if (index >= 0) {
      const newValue = !this.local_access[index].access
      this.onPermissionChange(model, action, newValue)
    }
  }

  public onPermissionChange(model: string, action: string, access: boolean) {
    if (model == 'all' && action == 'all') {
      if (this.scope === 'tenant') {
        this.local_access.forEach(i => {
          if (!i.access) {
            i.access = true
          } else {
            i.access = false
          }
        })
      } else {
        this.local_access.forEach(i => {
          if (this.mode == 'profile' && access && this.company.can(i.model, i.action)) {
            i.access = true
          } else if (
            this.mode == 'company'
            && access
            && this.user.company!.can(i.model, i.action)
          ) {
            i.access = true
          } else {
            i.access = false
          }
        })
      }
    } else if (model == 'profile' && action != 'view' && access) {
      this.local_access.forEach(i => {
        if (access && this.company.can(i.model, i.action)) {
          i.access = true
        } else {
          i.access = false
        }
      })
    } else if (access && action != 'view') {
      this.local_access[this.getAccessIndex(model, 'view')].access = true
    } else if (!access && action == 'view') {
      let idx = this.getAccessIndex(model, 'edit')

      if (idx >= 0) {
        this.local_access[idx].access = false
      }

      idx = this.getAccessIndex(model, 'delete')

      if (idx >= 0) {
        this.local_access[idx].access = false
      }
    }

    this.$emit('update:access', this.local_access)
  }

  public getAccessIndex(model: string, action: string) {
    let index = this.local_access.findIndex(
      item => item.model === model && item.action === action,
    )

    return index
  }

  public centralActionScopeDetector(arr: any) {
    const { tenantPermissions } = tenancy({})
    if (this.scope === 'tenant') {
      return tenantPermissions(arr)
    }
    return arr
  }

  public mounted() {
    this.access.forEach((fa: FeatureAccess) => {
      let permission = fa.access

      if (this.root) {
        const company_permission = this.company.access.find(
          p => p.model === fa.model && p.action === fa.action,
        )

        permission = company_permission ? company_permission.access : false
      }

      this.local_access.push(new FeatureAccess(fa.model, fa.action, permission, fa.options))
    })

    this.centralActionScopeDetector(this.base_profile.access)
      .map(item => item.model)
      .filter((value, index, self) => self.indexOf(value) === index)
      .forEach(item => {
        // @ts-ignore
        if (this.user.company.can(item)) {
          this.models.push(item)
        }
      })

    this.actions = this.centralActionScopeDetector(this.base_profile.access)
      .map(item => item.action)
      .filter((value, index, self) => self.indexOf(value) === index)

    if (!this.access.length) {
      this.models.forEach(model => {
        this.actions.forEach(action => {
          this.local_access.push(new FeatureAccess(model, action, false))
        })
      })
    }

    this.ready = true
  }
}
